import { render, staticRenderFns } from "./link-renderer.vue?vue&type=template&id=0e8f0b78&"
import script from "./link-renderer.vue?vue&type=script&lang=js&"
export * from "./link-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports